import {z} from 'zod';

// Zod schemas
export const EntityChangeResponseBodySchema = z.object({
  class: z.string(),
  property: z.string(),
  from: z.string().nullable(),
  to: z.string().nullable(),
});

export const RecordFieldChangeResponseBodySchema = z.object({
  property: z.string(),
  from: z.string().nullable(),
  to: z.string().nullable(),
});

export const ListEntityChangesApiResponseSchema = z.array(EntityChangeResponseBodySchema);

export const ListRecordFieldChangesApiResponseSchema = z.array(RecordFieldChangeResponseBodySchema);

export const ListEntityChangesApiArgSchema = z.object({
  commandId: z.string(),
});

export const ListRecordFieldChangesApiArgSchema = z.object({
  resourceId: z.string(),
  recordId: z.string(),
  commandId: z.string().optional(),
});

// Type definitions derived from schemas
export type EntityChangeResponseBody = z.infer<typeof EntityChangeResponseBodySchema>;
export type RecordFieldChangeResponseBody = z.infer<typeof RecordFieldChangeResponseBodySchema>;
export type ListEntityChangesApiResponse = /** status 200  */ z.infer<
  typeof ListEntityChangesApiResponseSchema
>;
export type ListRecordFieldChangesApiResponse = /** status 200  */ z.infer<
  typeof ListRecordFieldChangesApiResponseSchema
>;
export type ListEntityChangesApiArg = z.infer<typeof ListEntityChangesApiArgSchema>;
export type ListRecordFieldChangesApiArg = z.infer<typeof ListRecordFieldChangesApiArgSchema>;
